export default "__VITE_ASSET__DfCwzuNo__"